const moment = require("moment");

const PICKER_DATE_FORMAT = 'DD.MM.YYYY';
const HIDDEN_INPUT_PICKER_DATE_FORMAT = 'YYYY-MM-DD';


function parseDateFormat({date, parseDate = true, isForPicker = true, delimiter = '-'}) {
    if (!date) {
        return
    }

    if (parseDate) {
        const processedDate = date.split(delimiter);
        const year = processedDate[0];
        const month = processedDate[1];
        const day = processedDate[2];

        if (day && month && year) {
            return isForPicker
                ? day + '.' + month + '.' + year
                : day + '-' + month + '-' + year
        }
    }

    if (date) {
        return date;
    }
}


const dateRangePickerSettings = (minDate, maxDate) => {
    let ranges = {}
    if (!minDate || !maxDate) {
        ranges = {
            'Today': [
                moment(),
                moment()
            ],
            'Yesterday': [
                moment().subtract(1, 'days'),
                moment().subtract(1, 'days')
            ],
            'Last 7 Days': [
                moment().subtract(6, 'days'),
                moment()
            ],
            'Last 30 Days': [
                moment().subtract(29, 'days'),
                moment()
            ],
            'This Month': [
                moment().startOf('month'),
                moment().endOf('month')
            ],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month')
            ],
        }
    } else {
        ranges = {
            'All time': [
                moment(minDate, HIDDEN_INPUT_PICKER_DATE_FORMAT).toDate(),
                moment(maxDate, HIDDEN_INPUT_PICKER_DATE_FORMAT).toDate()
            ],
            'Today': [
                moment(),
                moment()
            ],
            'Yesterday': [
                moment().subtract(1, 'days'),
                moment().subtract(1, 'days')
            ],
            'Last 7 Days': [
                moment().subtract(6, 'days'),
                moment()
            ],
            'Last 30 Days': [
                moment().subtract(29, 'days'),
                moment()
            ],
            'This Month': [
                moment().startOf('month'),
                moment().endOf('month')
            ],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month')
            ],
        }
    }

    return ({
        showDropdowns: true,
        alwaysShowCalendars: true,
        linkedCalendars: false,
        showCustomRangeLabel: false,
        autoApply: true,
        ranges,
        locale: {
            format: PICKER_DATE_FORMAT,
            cancelLabel: window.helpers.trans('Reset')
        }
    })
}

const closeMobilePickerModal = (pickerObj) => {
    const getDatePicker = pickerObj.container ? $(pickerObj.container) : pickerObj
    $('body').removeClass('daterangepicker-opened')
    $(getDatePicker).removeClass('active')
}

const dateRangePickerMobileHeader = (pickerObj) => {
    const getDatePicker = $(pickerObj.container)
    $('body').addClass('daterangepicker-opened')
    $(getDatePicker).addClass('active')

    if ($(getDatePicker).find('.daterangepicker-mobile-header').length === 0) {
        $(getDatePicker).prepend(`
            <div class="modal-header daterangepicker-mobile-header border-0 d-md-none">
                <div class="d-flex align-items-center">
                    <span class='modal-icon-wrapper'>
                        <i class="icon-calendar"></i>
                    </span>
                    <h6 class="mb-0 fs-18 fw-700">Calendar</h6>
                </div>
                <button type="button" class="btn btn-close close-mobile-daterangepicker" data-dismiss="modal" aria-label="Close">
                    <i class="icon-decline"></i>
                </button>
            </div>`
        )

        getDatePicker.on('click', function (e) {
            if ($(e.target).hasClass('close-mobile-daterangepicker') ||
                $(e.target).parent().hasClass('close-mobile-daterangepicker') ||
                ($(e.target).hasClass('daterangepicker') && $(e.target).hasClass('active'))
            ) {
                pickerObj.element.data('daterangepicker').hide()
            }
        })
    }
}

const dateRangePickerMobileDropdownHandler = (pickerObj) => {
    const getDropdownBtn = $(pickerObj.container).find('.ranges-dropdown-btn')
    const getOptionsWrapper = $(pickerObj.container).find('.ranges ul')
    const getOptionsList = $(pickerObj.container).find('.ranges ul li')

    if (getOptionsWrapper.length && getDropdownBtn.length) {
        getOptionsList.each(function (index, item) {
            if ($(item).hasClass('active')) {
                getDropdownBtn.text($(item).text())
            }
        })
    }

    if (getOptionsWrapper.length && getDropdownBtn.length) {
        getOptionsWrapper.removeClass('active')
        getDropdownBtn.removeClass('active')
    }
}


const initDateRangePicker = ({
                                 type,
                                 desktopCalendarId,
                                 desktopInputStartDateId,
                                 desktopInputEndDateId,
                                 mobileCalendarId,
                                 mobileInputStartDateId,
                                 mobileInputEndDateId,
                                 drops = 'auto',
                                 opens = 'auto',
                                 dateFormat = HIDDEN_INPUT_PICKER_DATE_FORMAT,
                             }) => {
    const calendar = type === 'mobile' ? $(mobileCalendarId) : $(desktopCalendarId);

    const checkMobileInputs = (mobileInputStartDateId && $(mobileInputStartDateId).length > 0) &&
        (mobileInputEndDateId && $(mobileInputEndDateId).length > 0)
    const checkDesktopInputs = (desktopInputStartDateId && $(desktopInputStartDateId).length > 0) &&
        (desktopInputStartDateId && $(desktopInputEndDateId).length > 0)

    const startDate = calendar.data('start-date')
    const endDate = calendar.data('end-date')
    const minDate = calendar.data('min-date')
    const maxDate = calendar.data('max-date')

    if (calendar.length && startDate && endDate && minDate && maxDate) {
        calendar.daterangepicker({
            startDate: parseDateFormat({date: calendar.data('start-date')}),
            endDate: parseDateFormat({date: calendar.data('end-date')}),
            minDate: parseDateFormat({date: calendar.data('min-date')}),
            maxDate: parseDateFormat({date: calendar.data('max-date')}),
            drops: drops,
            opens: opens,
            ...dateRangePickerSettings(calendar.data('min-date'), calendar.data('max-date')),
        }).on('show.daterangepicker', function (ev, picker) {
            dateRangePickerMobileDropdownHandler(picker)
            dateRangePickerMobileHeader(picker)
        }).on('apply.daterangepicker', function (ev, picker) {
            closeMobilePickerModal(picker);
            dateRangePickerMobileDropdownHandler(picker)
        }).on('hide.daterangepicker', function (ev, picker) {
            closeMobilePickerModal(picker);
        })
    }

    $('.drp-calendar.right').hide();
    // $('.drp-calendar.left').addClass('single');

    calendar.on('apply.daterangepicker', function (ev, picker) {
        if (type === 'mobile' && checkMobileInputs) {
            $(mobileInputStartDateId).val(picker.startDate.format(dateFormat))
            $(mobileInputEndDateId).val(picker.endDate.format(dateFormat)).trigger('change')
            if (checkDesktopInputs && desktopCalendarId && $(desktopCalendarId).length > 0) {
                $(desktopCalendarId).data('daterangepicker').setStartDate(picker.startDate.format(PICKER_DATE_FORMAT))
                $(desktopCalendarId).data('daterangepicker').setEndDate(picker.endDate.format(PICKER_DATE_FORMAT))
            }
        } else if (checkDesktopInputs) {
            $(desktopInputStartDateId).val(picker.startDate.format(dateFormat))
            $(desktopInputEndDateId).val(picker.endDate.format(dateFormat)).trigger('change')

            if (checkMobileInputs && mobileCalendarId && $(mobileCalendarId).length > 0) {
                $(mobileCalendarId).data('daterangepicker').setStartDate(picker.startDate.format(PICKER_DATE_FORMAT))
                $(mobileCalendarId).data('daterangepicker').setEndDate(picker.endDate.format(PICKER_DATE_FORMAT))
            }
        }
    });

    calendar.on('cancel.daterangepicker', function (ev, picker) {
        if (type === 'modal') {
            $(mobileInputStartDateId).val(calendar.data('start-date'))
            $(mobileInputEndDateId).val(calendar.data('max-date'))
            $(desktopCalendarId).data('daterangepicker').setStartDate(calendar.data('start-date'))
            $(desktopCalendarId).data('daterangepicker').setEndDate(calendar.data('max-date'))
        } else {
            $(desktopInputStartDateId).val(calendar.data('start-date'))
            $(desktopInputEndDateId).val(calendar.data('max-date'))
            $(mobileCalendarId).data('daterangepicker').setStartDate(calendar.data('start-date'))
            $(mobileCalendarId).data('daterangepicker').setEndDate(calendar.data('max-date'))
        }
    });
}

function setDateRangePicker({
                                mainInputId,
                                hiddenInputStartId,
                                hiddenInputEndId,
                                triggerOnChange = false,
                                startDate = '',
                                endDate = '',
                            }) {
    const getStartDate = startDate ? startDate : $(mainInputId).data('start-date')
    const getEndDate = endDate ? endDate : $(mainInputId).data('max-date')
    if (getEndDate && getStartDate) {
        $(mainInputId).data('daterangepicker').setStartDate(startDate
            ? parseDateFormat({date: startDate})
            : getStartDate
        );
        $(mainInputId).data('daterangepicker').setEndDate(endDate
            ? parseDateFormat({date: endDate}) :
            getEndDate
        );

        $(hiddenInputStartId).val(parseDateFormat({
                date: getStartDate,
                isForPicker: false,
                delimiter: '.'
            }
        ));

        // add trigger('change') to make a request when hidden input value changed
        if (triggerOnChange) {
            return $(hiddenInputEndId)
                .val(parseDateFormat({
                    date: getEndDate,
                    isForPicker: false,
                    delimiter: '.'
                }))
                .trigger("change");
        }
        $(hiddenInputEndId).val(parseDateFormat({
            date: getEndDate,
            isForPicker: false,
            delimiter: '.'
        }));
    }
}

function singleValueDateRangePicker({
                                        calendarId,
                                        hiddenInputId = null,
                                        dateFormat = PICKER_DATE_FORMAT,
                                        dropsFrom = "auto"
                                    }) {
    const calendar = $(calendarId);
    const hiddenInput = $(hiddenInputId);

    const startDate = calendar.data('start-date')
    const minDate = calendar.data('min-date')
    const maxDate = calendar.data('max-date')

    if (startDate && minDate && maxDate) {
        calendar.daterangepicker({
            startDate: parseDateFormat({date: startDate}),
            minDate: parseDateFormat({date: minDate}),
            maxDate: parseDateFormat({date: maxDate}),
            showDropdowns: true,
            alwaysShowCalendars: true,
            linkedCalendars: false,
            showCustomRangeLabel: false,
            autoApply: true,
            singleDatePicker: true,
            dropsFrom: dropsFrom,
            locale: {
                format: dateFormat,
                cancelLabel: window.helpers.trans('Reset')
            },
        });
    }

    calendar.on('apply.daterangepicker', function (ev, picker) {
        calendar.val(picker.startDate.format(dateFormat))
        if (hiddenInput.length) {
            hiddenInput.val(picker.startDate.format(HIDDEN_INPUT_PICKER_DATE_FORMAT))
        }
    })
}

function getDateRangePickerFormat() {
    if ($('html').attr('lang') === 'ja') {
        return 'YYYY年MM月DD日'
    }

    // return 'yyyy.mm.dd'
    return 'YYYY.MM.DD'
}


module.exports = {
    initDateRangePicker,
    dateRangePickerSettings,
    dateRangePickerMobileDropdownHandler,
    setDateRangePicker,
    singleValueDateRangePicker,
    getDateRangePickerFormat
}
